// extracted by mini-css-extract-plugin
export default {"container":"MobPage_container__lpS5O","row":"MobPage_row__LPkYl","filters":"MobPage_filters__+YG2Z","filters-mobile-container":"MobPage_filters-mobile-container__k-KUb"};